import React from 'react';
import AddTagControl from '../AddTagControl';
import { TagMenuType } from '../Types/TagTypes';

function TagMenu(props: TagMenuType) {
	const HandleCallback = (tag: any, checked: boolean) => {
		props.updateCallback(tag, checked);
	};

	return (
		<AddTagControl
			data={props.data}
			listAlwaysVisible
			listInMenu
			name='tagMenu'
			menuToggled={props.reRenderTrigger}
			dataKey={props.dataKey}
			updateCallback={(e: any, b: boolean) => HandleCallback(e, b)}
		/>
	);
}

export { TagMenu };
